import { useMemo } from 'react';
import {
  githubDarkTheme,
  githubLightTheme,
  monoDarkTheme,
  monoLightTheme,
} from 'json-edit-react';

import { useTheme, THEME_MODES } from './ThemeProvider';

// Editors that sit on the code ground (DeveloperCodeView) are always dark and
// only need to re-anchor their container to the theme's code surface.
export const CODE_EDITOR_THEME = [
  githubDarkTheme,
  { container: { backgroundColor: 'var(--if-code-bg)' } },
];

const VARIANTS = {
  github: { light: githubLightTheme, dark: githubDarkTheme },
  mono: { light: monoLightTheme, dark: monoDarkTheme },
};

const NO_CONTAINER = {};

// Editors that sit on regular form surfaces follow the active theme.
export default function useJsonEditorTheme(
  variant = 'github',
  container = NO_CONTAINER,
) {
  const { theme } = useTheme();
  return useMemo(() => {
    const base = VARIANTS[variant] || VARIANTS.github;
    const isDark = theme !== THEME_MODES.LIGHT;
    return [base[isDark ? 'dark' : 'light'], { container }];
  }, [theme, variant, container]);
}
